var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isAuthenticated)?_c('the-navigation-layout',{attrs:{"items":_vm.items}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }